import { useEffect, useMemo, useState } from "react";

import Label from "./Label";
import Errors from "./Errors";
import Input from "./Input";
import classNames from "classnames";
import Hint from "./Hint";
import {
  GOVGR_DATE_INPUT,
  GOVGR_FIELD,
  GOVGR_FIELD__ERROR,
} from "../../conf/styles/GovGrDate";
import dayjs from "dayjs";

const DAY_LABEL = "Ημέρα";
const MONTH_LABEL = "Μήνας";
const YEAR_LABEL = "Έτος";

const B_DAY = "b-day";
const BDAY_DAY = "bday-day";
const B_MONTH = "b-month";
const BDAY_MONTH = "bday-month";
const B_YEAR = "b-year";
const BDAY_YEAR = "bday-year";

const defaultFormatFunction = (day, month, year) => {
  if (!year || year < 1800 || year > 2200) {
    return new Date(`${20000000}-${month}-${day}`);
  }
  if (!day) {
    return new Date(`${20000000}-${month}-${day}`);
  }

  return new Date(`${year}-${month}-${day}`);
};

const DateComponent = ({
  field,
  form,
  dayInputProps = {},
  monthInputProps = {},
  yearInputProps = {},
  containerProps = {},
  formatFunction = defaultFormatFunction,
  dayLabel = DAY_LABEL,
  monthLabel = MONTH_LABEL,
  yearLabel = YEAR_LABEL,
  ...props
}) => {
  const [day, setDay] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();

  useEffect(() => {
    if (!!field?.value?.getDate()) {
      setDay(field?.value?.getDate());
    }

    if (!!field?.value?.getMonth()) {
      setMonth(
        !!field?.value?.getMonth() || !isNaN(field?.value?.getMonth())
          ? field?.value?.getMonth() + 1
          : ""
      );
    }
    if (!!field?.value?.getFullYear()) {
      setYear(field?.value?.getFullYear());
    }
  }, [field.value]);

  useEffect(() => {
    form.setFieldValue(field?.name, formatFunction(day, month, year));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [day, month, year]);

  const handleDayChange = (e) => {
    setDay(e.target.value);
  };

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
  };

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  const checkErrorsAndTouchFields = useMemo(
    () => form.touched[field.name] && !!form.errors[field.name],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      form.touched,
      field.name,
      field?.touched?.[field.name],
      form?.errors?.[field.name],
    ]
  );

  const containerClassName = classNames(GOVGR_FIELD, {
    [GOVGR_FIELD__ERROR]: checkErrorsAndTouchFields,
  });
  if(month === undefined) {
    setMonth("01");
  }
  return (
    <div className={containerClassName} {...containerProps}>
      <Label
        label={props.label}
        disabled={props.disabled}
        example={props.example}
      />

      <Hint disabled={props.disabled} hint={props.hint} />

      <Errors
        isErrorAndTouched={checkErrorsAndTouchFields}
        disabled={props.disabled}
        hint={props.hint}
        error={form?.errors?.[field.name]}
      />

      <div className={GOVGR_DATE_INPUT}>
        <Input
          label={dayLabel}
          isErrorAndTouched={checkErrorsAndTouchFields}
          name={B_DAY}
          autoComplete={BDAY_DAY}
          value={day}
          disabled={props.disabled}
          form={form}
          field={field}
          handleChange={handleDayChange}
          {...dayInputProps}
        />

        <Input
          label={monthLabel}
          name={B_MONTH}
          isErrorAndTouched={checkErrorsAndTouchFields}
          autoComplete={BDAY_MONTH}
          form={form}
          field={field}
          value={month}
          handleChange={handleMonthChange}
          disabled={props.disabled}
          {...monthInputProps}
        />

        <Input
          label={yearLabel}
          name={B_YEAR}
          isErrorAndTouched={checkErrorsAndTouchFields}
          autoComplete={BDAY_YEAR}
          form={form}
          field={field}
          value={year}
          handleChange={handleYearChange}
          disabled={props.disabled}
          {...yearInputProps}
        />
      </div>
    </div>
  );
};

export default DateComponent;
